var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{style:(("background:" + (_vm.$vuetify.theme.currentTheme[_vm.layoutOptions.mainBackground])))},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }